/**
 * Created by neo on 01.02.21.
 */
import { makeAutoObservable } from 'mobx';
import { TagCondition, createTagCondition } from '../Coach/SuperMacro/TagCondition';
import { MediaNarratorAudioTrack, createMediaNarratorAudioTrack } from './MediaNarratorAudioTrack';
import { Media } from '../Media/Media';
import { languagePriority } from '../LocalizedEntity';
import { Instructor, createInstructor } from './Instructor';

export type MeditationNarrator = Instructor & {
  tagConditions: TagCondition[];
  audioTracks: MediaNarratorAudioTrack[];
  readonly defaultAudioTrack: Media;
  getAudioTrack(lang: string): Media;
};

export function createMeditationNarrator(json?: Partial<MeditationNarrator>): MeditationNarrator {
  const base = createInstructor(json as any);
  return makeAutoObservable({
    ...base,
    tagConditions: (json?.tagConditions ?? []).map((t: any) => createTagCondition(t)),
    audioTracks: (json?.audioTracks ?? []).map((a: any) => createMediaNarratorAudioTrack(a)),

    get defaultAudioTrack(): Media {
      for (const lang of languagePriority) {
        const entry = this.audioTracks.find((l) => l.language === lang);
        if (entry) return entry.media;
      }
      return this.audioTracks[0]?.media;
    },

    getAudioTrack(lang: string): Media {
      return this.audioTracks.find((n) => n.language === lang.toLowerCase())?.media || this.defaultAudioTrack;
    },
  });
}
